export default {
    // ========== Actions with evaluations ==========
    replicateEvaluationTo: 'Replicate the {entity} to other {sections}',

    // ========== Replication messages ==========
    replicatedEvaluations: 'Replicated {entity}',
    replicatedEvaluationsFeminine: 'Replicated {entity}',
    evaluationsReplicatedInSections: 'The {entity} were replicated in the following sections:',
    evaluationUpdatedInSection: 'The {entity} was updated in the following section:',
    instrumentsReplicatedInEvaluations: 'The {entity} were replicated in the following evaluations:',
    recreated: 'Recreated',
    selectSectionsToUpdate: 'Select the {entity} to update:',
    selectSectionsToReplicate: 'Select the {entity} to replicate to:',
    selectEvaluationsToReplicate: 'Select the evaluations to replicate to:',
    selectOneOrMoreToFilter: 'Select one or more to filter.',

    // ========== Tooltips and informative messages ==========
    additionalInformationOf: 'Additional information of {entity}',
    notAvailable: 'not available',
    closed2: 'closed',
    closed3: 'closed',
    closedParentheses: '(Closed)',
    removeOption: 'Remove option',
    toOtherEvaluations: 'to other Evaluations',
    pressToViewColorMeaning: 'Press to view the meaning of colors in the {entity}.',
    colorInformationFor: 'Color information for the {entity}.',
    goToEntity: 'Go to the {entity}',
    lockEntity: 'Lock {entity}',
    unlockEntity: 'Unlock {entity}',
    isClosedEntity: '{entity} is closed',
    viewAsStudent: 'View as Student',
    viewAsTeacher: 'View as Teacher',
    assignedScore: 'Assigned score',
    teacherInstructions: 'Teacher Instructions',
    studentInstructions: 'Student Instructions',
    teacherFormat: 'Teacher Format',
    studentFormat: 'Student Format',
    instructionsAndGuidelineTeacher: 'Instructions and Guideline for Teacher',
    instructionsAndGuidelineStudent: 'Instructions and Guideline for Student',
    rubric: 'Rubric',
    answerKeys: 'Answer Keys',
    noInstrumentCreated: 'No {entity} has been created.',
    toCreateNewInstrument: 'To create a new {entity} select the "Add {entity}" button.',
    noInstrumentAvailableForEvaluatee: 'There are no {entity} available to answer at this time.',
    noInstrumentAvailableForEvaluator: 'There are no {entity} available to grade at this time.',

    // ========== Confirmations and alerts ==========
    confirmationRequired: 'Confirmation Required',
    sureCloseUnsavedData: 'Are you sure you want to close? Unsaved data will be lost.',
    yesClose: 'Yes, close',
    accessDenied: 'Access Denied',
    noPermissionForAction: 'You do not have permission to perform this action',
    all: '-- ALL --',

    // ========== Color descriptions ==========
    indicatesNotExistsCanReplicate: 'Indicates that it does not exist, so it can be replicated directly.',
    indicatesExistsCannotReplicate: 'Indicates that it exists, so it cannot be replicated directly, manage through {entity}.',

    // ========== Printing ==========
    fullEvaluationPrint: 'Full evaluation print',

    // ========== Modal titles ==========
    updateEvaluationInCreatedSections: 'Update the {entity} in the created {sections}',
    replicateEvaluation: 'Replicate the {entity}',
    replicateEvaluationInOtherSections: 'Replicate the {entity} in the other {sections} of the {subject}',
    selectFiles: 'Select Files',

    // ========== Header evaluation ==========
    type: 'Type',
    weighting: 'Weighting',
    weightingMustBe100: 'Weighting must be 100%',
    sumWeightingsMustBe100: 'Sum of weightings must be 100%',
    noStartDate: 'No Start Date',
    noEntityForEntity: 'No {entity1} for this {entity2}',
    replicateInstrumentInOtherEvaluations: 'Replicate {entity} in other evaluations',
    sureToDeleteEntityAndInstruments: 'Are you sure you want to delete the {entity} and its created instruments?',
    wasDeletedThe: 'The',
    wasDeletedTheMale: 'The',
    createdBy: 'Created by',
    creationDate: 'Creation Date',
    attachedFiles: 'Attached Files',
    addAttachedFile: 'Add Attached File',

    // ========== Header output format ==========
    acronym: 'Acronym',
    subjectName: 'Subject Name',
    assignedTime: 'Assigned Time',
    percentageWeighting: '% Weighting',
    hours: 'Hours',

    // ========== View evaluation grade ==========
    grade: 'Grade',
    obtainedGrade: 'Obtained Grade',
    obtained: 'Obtained',
    assigned: 'Assigned',
    automatic: 'Automatic',
    useAutomaticGrade: 'Use automatic grade',
    gradeUpdated: 'Grade updated.',

    // ========== Evaluatee carousel ==========
    currentlyEvaluating: 'Currently evaluating',
    selectStudent: 'Select Student',
    sortByFirstName: 'Sort by First Name',
    sortByLastName: 'Sort by Last Name',
    pressToViewIconLegend: 'Press to view the Evaluatee Icon Legend',
    evaluateeIconLegend: 'Evaluatee Icon Legend',
    information: 'Information',
    icon: 'Icon',
    evaluateeStartedEvaluation: 'Evaluatee who has already started their {entity}',
    evaluateeStartedButNotFinished: 'Evaluatee who started the {entity} but did not finish it',
    evaluateeFinishedEvaluation: 'Evaluatee who has already finished their {entity}',
    evaluateeNotStarted: 'Evaluatee who has not yet started their {entity}',
    evaluateeGradePublished: 'Evaluatee whose grade/score has already been published',
    groupLeader: 'Group Leader',
    previousUncorrected: 'Previous uncorrected',
    goToPrevious: 'Go to previous',
    goToNext: 'Go to next',
    nextUncorrected: 'Next uncorrected',
    noStudentsSelected: 'No students selected.',

    // ========== New evaluation form ==========
    step1DetailsOf: 'Step 1: Details of the {entity}',
    step1DetailsOf2: 'Step 1: Details of the {entity}',
    step2AssignEvaluatees: 'Step 2: Assign Evaluatee(s)',
    step3AssignEvaluators: 'Step 3: Assign Evaluator(s)',
    title: 'Title',
    randomQuestions: 'Random Questions',
    randomQuestionsTooltip: 'This option allows the Student to view the {entity} questions randomly.',
    randomAlternatives: 'Random Alternatives',
    randomAlternativesTooltip: 'This option allows the Student to view the {entity} multiple-choice question alternatives randomly.',
    evaluativeAgent: 'Evaluative Agent',
    allowAutoEvaluate: 'Allow Self-Evaluation',
    allowAutoEvaluateTooltip: 'This option allows the Evaluatee to answer the rubric.',
    requiredGreaterOrEqualZero: 'This field is required, must be greater than or equal to 0',
    andCannotExceed: 'and cannot exceed {value}%.',
    workType: 'Work Type:',
    workTypeLabel: 'Work Type',
    examiner: 'Examiner:',
    allowModifyDates: 'Allow date modification',
    allowModifyDatesTooltip: 'This option allows Teachers to modify dates',
    defineStartDate: 'Define start date',
    mustEnterValidStartDate: 'You must enter a valid start date.',
    startTime: 'Start Time',
    defineStartTime: 'Define start time',
    mustEnterStartTime: 'You must enter the start time.',
    nameOf: 'Name of the {entity}',
    descriptionOf: 'Description of the {entity}',
    editDescriptionOf: 'Edit Description of the {entity}',
    editDescriptionOf2: 'Edit Description of the {entity}',
    evaluationType: 'Evaluation Type',
    weightingOf: 'Weighting of the {entity}',
    requiredAndGreaterThanZero: 'This field is required and must be greater than 0.',
    category: 'Category',
    selectFile: 'Select File',
    files: 'Files',
    formFieldsDisabled: 'The fields of this form are disabled and to edit them go to {entity}.',
    mustBeGreaterThanZeroAnd: 'Must be greater than 0 and',
    requiredFieldAnd: 'This field is required and',
    mustNotExceed: 'Must not exceed',
    previousStep: 'Previous step',
    nextStep: 'Next step',
    lockCreationOf: 'Lock creation of {entity}',
    createdSuccessfully: 'The {entity} was created',
    editedSuccessfully: '{entity} edited successfully',

    // ========== Specification table ==========
    specificationTable: 'Specification Table',
    learningOutcome: 'Learning Result',
    achievementIndicator: 'Achievement Indicator',
    achievementIndicatorWeighting: 'Achievement Indicator Weighting',
    evaluationIndicatorWeighting: 'Evaluation Indicator Weighting',
    questionOrItemNumber: 'Question or Item Number',
    toAddEntityMustCreateEntity: 'To add a {entity1} you must create a {entity2}',
    sumWeightingGreaterThan: 'The sum of the (IE) weightings is greater than the (IL) weighting',
    total: 'Total',
    totalWeightingMustEqual100: 'The total weighting must equal 100.',
    forTheEvaluation: 'For the Evaluation',

    // ========== Rubric form ==========
    titleOf: 'Title of the {entity}',
    titleOf2: '{entity} title',
    editTitleOf: 'Edit Title of the {entity}',
    evaluationCriteriaMicro: '{entity1} of the {entity2}',
    optionalField: 'This field is optional.',
    showToEvaluatees: 'Show Evaluatees',
    ifThisOptionIsSelectedContent: 'If this option is selected the content will be visible to the Evaluatee',
    entityBy: '{entity} by',
    addDescriptorTo: 'Add Descriptor to {entity}',
    showCoevaluator: 'Show Coevaluator',
    showsEvaluateeWhoEvaluated: 'Shows the evaluatee who was the person who evaluated them.',
    coevaluationType: 'Coevaluation type',
    selectMultipleAllowsRepeated: 'By selecting multiple, it allows selecting several coevaluated even if they are repeated in a coevaluation.',
    simpleCoevaluation: 'Simple coevaluation',
    multipleCoevaluation: 'Multiple coevaluation',
    percentage: 'Percentage',
    score: 'Score',
    showDescriptors: 'Show Descriptors',
    hideDescriptors: 'Hide Descriptors',
    selectMethod: 'Select the method:',
    congruentSelfEvaluationMethod: 'Congruent self-evaluation method (Mac)',
    gradesDependOnCoincidence: 'The grade depends on the coincidence of grades between the Evaluator and the self-evaluator.',
    weightedGradingMethod: 'Weighted grading method',
    percentageIndicatesWeighting: 'The percentage indicates the weighting of the grade that the student assigns to themselves, where 0 is irrelevant and 100 is maximum.',
    studentWeightingMessage: 'The student has a weight in the weighting of {percentage}% in the evaluation, which means that the teacher has the remaining {remaining}%.',
    fieldMustBeBetween0And100: 'This field must be a value between 0 and 100.',
    fieldMustBePositiveInteger: 'This field must be a positive integer.',
    instrumentTypes: 'Instrument Types',
    preview: 'Preview',
    sureToSaveEntityWithMultipleCoevaluated: 'Are you sure you want to save the {entity} being that there are <b>multiple coevaluated assigned</b>?',
    actionCannotBeRevertedCoevaluatorsReset: 'This action cannot be undone and the coevaluators will be reset!',
    evaluateesUnassignedSuccessfully: 'Evaluatees Unassigned Successfully',
    entityCreated: '{entity} created.',
    entityEdited: '{entity} edited.',

    // ========== Rubric preset preview ==========
    noAchievementLevelsToShow: 'No achievement levels to show.',
    percentageAchievement: '% Achievement',
    achievementLevelsDescription: 'Achievement Levels Description',

    // ========== Rubric criteria form ==========
    availableWeighting: 'Available weighting:',
    fieldMustBeBetween0AndMax: 'This field must be a value between 0 and {max}.',
    fieldMustBe0: 'This field must be 0',
    fieldMustBeNumberGreaterThan0: 'This field must be a number greater than 0.',
    maxTwoDecimals: 'Maximum two decimals.',
    savingEntity: 'Saving {entity}...',
    pleaseWaitWhileSavingObject: 'Please wait while the object is being saved.',
    entityCreatedFeminine: '{entity} created.',
    entityUpdatedFeminine: '{entity} updated.',
    problemSavingEntity: 'There was a problem saving the {entity}.',
    sureToDeleteEntity: 'Are you sure you want to delete the {entity}?',
    entityDeletedFeminine: '{entity} deleted.',

    // ========== Specification table - Input ==========
    changeNotSavedWeightingExceeds100: 'Change not saved because weighting exceeds 100%.',
    weightingUpdated: 'Weighting updated',

    // ========== Instrument header ==========
    scoreObtained: 'Score Obtained',
    feedback: 'Feedback',
    description: 'Description',
    attachmentsForTeacher: 'Attachments for Teacher',
    attachmentsForTeacherTooltip: 'These Attachments are only visible to Administrators and Teachers.',
    addFile: 'Add File',
    attachmentsForStudent: 'Attachments for Student',
    attachmentsForStudentTooltip: 'Students with access to the evaluation will be able to see these attachments, along with Administrators and Teachers.',
    scoreOf: 'Score of {entity}',
    currentScoreOfQuestions: 'Current score of questions',
    questionScoreGreaterThanEntity: 'The score of the questions is greater than the score of the {entity}',
    questionScoreLessThanEntity: 'The score of the questions is less than the score of the {entity}',
    equalizeScoreWithQuestions: 'Equalize total score with respect to current score of questions',
    reviewStudentView: 'Review Student view',
    returnToTeacherView: 'Return to Teacher view',
    scoreUpdatedOf: 'The score of {entity} was updated',

    // ========== InfoTest ==========
    readyToClose: 'ready to close.',
    closed: 'closed.',
    instrumentIsValid: 'This {entity} is valid. It is ready to be published.',
    closingInstrumentAllowsActions: 'By closing the {entity}, it will be possible to close the Subject, copy the {entity} and create new sections.',
    pressToCloseInstrument: 'If you want to close the {entity} press this button',
    pressToReopenInstrument: 'If you want to reopen the {entity} press this button',
    problemsFound: 'Problems found:',
    pressToViewErrors: 'Press here to view the errors',
    informationOf: 'Information {entity}',
    closeEntity: 'Close {entity}',
    closingWillMakeAvailableToEvaluatees: 'This will make the {entity} available to evaluatees',
    closedSuccessfully: 'The {entity} was closed successfully',
    openEntity: 'Open {entity}',
    openingWillMakeUnavailableToEvaluatees: 'This will make the {entity} no longer available to evaluatees',
    openedSuccessfully: 'The {entity} was opened successfully',

    // ========== GroupsContainer ==========
    groups: 'GROUPS',
    addGroup: 'Add Group',
    copyGroup: 'Copy Group',
    createGroup: 'Create Group',
    selectEntity: 'Select {entity}',
    groupsCopied: 'Groups Copied',
    groupCopied: 'Group Copied',

    // ========== GroupsForm ==========
    groupName: 'Group Name',
    selectGroupMembers: 'Select Group Members',
    studentAlreadyInGroup: 'This student is already in a Group',
    selectGroupLeader: 'Select Group Leader',
    selectLeaderOfGroup: 'Select Group Leader',
    noResultsFoundFor: 'No results found for',
    groupCreated: 'Group created',
    groupEdited: 'Group edited',
    sureToDeleteGroup: 'Are you sure you want to delete the <b>Group</b>?',
    groupDeleted: 'Group deleted',

    // ========== GroupsTable ==========
    groupMembers: 'Group Members',
    studentInGroupName: 'This student is in the Group: \'\'{groupName}\'\'',
    editGroup: 'Edit Group',
    deleteGroup: 'Delete Group',
    noGroupsEntered: 'No groups have been entered',
    sureToDeleteTheGroup: 'Are you sure you want to delete the Group?',
    entityDeleted: '{entity} deleted',

    // ========== NewSpecificationTable ==========
    byQuestion: 'BY QUESTION',
    questions: 'Questions',
    addQuestion: 'Add Question',
    editQuestion: 'Edit Question',
    editEntity: 'Edit {entity}',
    byCriteria: 'BY CRITERIA',
    byCognitiveLevel: 'BY COGNITIVE LEVEL',
    pressToViewCognitiveLevelColors: 'Press to view the colors of the {entity}.',
    cognitiveLevelInformation: 'Information about {entity}.',
    createQuestion: 'Create Question',
    development: 'Development',
    selection: 'Selection',
    matching: 'Matching',
    multiple: 'Multiple',
    simple: 'Simple',
    extensive: 'Extensive',
    brief: 'Brief',

    // ========== NewQuestionForm ==========
    questionTypeLabel: 'Question type',
    questionSubTypeLabel: 'Question subtype',
    questionTypeNotBelongToEntity: 'The selected Question type does not belong to the {entity}.',
    questionSubTypeNotBelongToEntity: 'The selected Question subtype does not belong to the {entity}.',
    scoreExceededBy: 'The score was exceeded by: {score}, with respect to the selected IE.',
    availableScoreIs: 'Available score is: {score}, corresponding to the selected IE.',
    questionCreated: 'Question created.',
    questionEdited: 'Question edited.',
    questionDeleted: 'Question deleted',
    questionUpdated: 'Question updated',
    sureToDeleteQuestion: 'Are you sure you want to delete the question?',
    redoQuestionWithAi: 'Regenerate the question with AI',
    redoQuestionWithAiTitle: 'Regenerate this question with AI?',
    redoQuestionWithAiText: 'The prompt, the expected answer and, for choice questions, its alternatives will be replaced. The Learning Indicator, type, score and order are kept.',
    redoQuestionWithAiDone: 'The question was regenerated.',
    questionScoreDoesNotMatchInstrument: 'The question score does not match the maximum score of the {entity}!',
    shouldInstrumentScoreBeUpdatedAutomatically: 'Should the {entity} score be updated automatically?',
    prefilledFromDesign: 'Filled in from what the "{piece}" evaluation declares in the Instructional Design. Review it before saving.',

    // ========== NewCognitiveLevelDimensionsST ==========
    cognitiveLevel: 'Cognitive level',
    quantityOf: 'Quantity of',

    // ========== NewEvaluationCriterialDimensionsST ==========
    statement: 'Statement',
    quantity: 'Quantity',
    orderNumber: 'Order number',

    // ========== NewCognitiveLevelST ==========
    totalScoreOf: 'Total score of',
    questionSubType: 'Question sub-type',
    briefDevelopment: 'Brief development',
    extensiveDevelopment: 'Extensive development',
    simpleSelection: 'Simple selection',
    multipleSelection: 'Multiple selection',
    addedScore: 'Added score',
    questionNumber: 'Question No.',

    // ========== CorrectAnswerComponent ==========
    item: 'Item',
    key: 'Key',

    // ========== RubricsContainer ==========
    hideColumns: 'Hide columns',
    number: 'Number',
    points: 'Points',
    manualScoreFeedback: 'Manual score / Feedback',
    doesNotHave: 'Does not have',
    feedbackLabel: 'Feedback',
    evaluatedDimension: '{entity} evaluated',
    withoutFeedback: 'Without feedback',
    created: 'created',
    mustBeBetween: 'Must be between {entity1} and {entity2}',
    editFeedback: 'Edit feedback',
    viewEditFeedback: 'View/Edit feedback',
    addFeedback: 'Add feedback',
    viewFeedback: 'View feedback',
    feedbackSaved: 'Feedback saved',
    manualScoreSaved: 'Manual score saved',
    invalidScore: 'Invalid score',
    scoreValueRequired: 'You must enter a valid score',
    valueRequired: 'Value required',
    scoreMustBeValidNumber: 'The score must be a valid number',
    saveScore: 'Save score',
    thisNoCreated: 'There are no {entity} created',
    assignEntityToEntity: 'Assign the {entity1} to the complete {entity2}',
    correspondsToPonderationOf: 'Corresponds to the weighting of the {entity}',
    updatingScoresOf: 'Updating scores of the {entity}...',
    pleaseWaitWhileLoading: 'Please wait while loading.',
    entityDoesNotWeigh: 'This {entity} does not weigh',
    sureDeleteEntityFromRubric: 'Are you sure you want to delete this instance of "{entity}" from the rubric?',
    sureDeleteRubric: 'Are you sure you want to delete the rubric?',
    rubricDeleted: 'Rubric deleted',
    entityIsUnlockedAndClosed: 'The {entity} is unlocked and closed',
    entityIsLockedAndClosed: 'The {entity} is locked and closed',
    selectWhereToApplyCopy: 'Select where the copy will be applied',
    copyRubric: 'Copy rubric',
    coevaluation: 'Coevaluation',
    assignStudentsRandomly: 'Assign students randomly',
    assign: 'Assign',
    firstNames: 'First names',
    lastNames: 'Last names',
    coevaluate: 'Coevaluate',
    coevaluator: 'Coevaluator',
    coevaluators: 'Coevaluators',
    youAreCoevaluating: 'You are coevaluating',
    oneStudentCount: '1 student',
    studentsCount: '{count} students',
    evaluated: 'Evaluated',
    missingEvaluation: 'Missing evaluation',
    evaluateesAssignedSuccessfully: 'Evaluatees assigned successfully',
    evaluateesLeftUnassigned: 'Peer evaluators were assigned, but {count} evaluatees were left without a pair: they are alone in their group or their manual assignments do not allow completing pairs. Assign them manually.',
    evaluateeAssignedSuccessfully: 'Evaluatee assigned successfully',
    evaluateeRemoved: 'Evaluatee removed',
    andLessThanOrEqualTo100: 'and less than or equal to 100',
    teacherResponse: 'Teacher response',
    coevaluatorResponse: 'Coevaluator response',
    evaluateeResponse: 'Evaluatee response',
    descriptorCreated: 'Descriptor created',
    descriptorUpdated: 'Descriptor updated',
    scoreUpdated: 'Score updated',

    // ========== EvaluateeTime ==========
    remainingTime: 'Remaining Time',
    questionsAnswered: 'Questions answered',
    finishedWaitingCorrection: '{entity} finished (Waiting for correction)',
    corrected: 'Corrected',

    // ========== EvaluatorTestScore ==========
    evaluate: 'Evaluate',
    status: 'Status',
    notStarted: 'Not started',
    startedOn: 'Started on',
    evaluateeAttachments: 'Evaluatee Attachments',
    proposedScore: 'Proposed Score',
    maximumScore: 'Maximum Score',
    applyAutomaticScore: 'Apply Automatic Score',
    noteOf: 'Grade of',
    publish: 'Publish',
    missingToEvaluate: '{count} {entity} missing to evaluate',
    revertPublication: 'Revert publication',
    replicateGradeToGroup: 'Replicate grade to group',
    selectEvaluatees: 'Select Evaluatees',
    copyFeedback: 'Copy Feedback',
    evaluatorAttachment: 'Evaluator Attachment',
    attachFile: 'Attach File',
    instrumentScoreUpdated: 'Instrument score updated.',
    feedbackUpdated: 'Feedback updated.',
    scorePublished: 'Score published.',
    gradesReplicated: 'Grades Replicated',
    evaluatees: 'Evaluatees',
    evaluateesSelected: 'Evaluatees selected',

    // ========== BodyInstrument ==========
    notAllowedToPrintWhileRunning: '🚫 Printing is not allowed while the {entity} is running.',
    editTitle: 'Edit title',
    entityUnlockedAndClosed: 'The {entity} is unlocked and closed.',
    entityLockedAndClosed: 'The {entity} is locked and closed.',
    writeStatementTitle: 'Write statement title',
    sureDeleteEntityAndQuestions: 'Are you sure you want to delete the {entity} and its Questions?',
    deleteGroup2: 'Delete group',
    only: 'Only',

    // ========== QuestionsContainer ==========
    addQuestionInsideSegment: 'Add Question inside {entity}',
    question: 'Question',

    // ========== NewQuestionCard ==========
    achievementIndicators: 'Achievement Indicators',
    noAssociatedIndicator: 'No Achievement Indicator has been associated with the Question',
    indicatorAssociatedToQuestion: 'Achievement Indicator associated with the question',
    indicatorsAssociatedToQuestion: 'Achievement Indicators associated with the question',
    questionUnlockedAndClosed: 'The Question is unlocked and closed.',
    lockQuestion: 'Lock Question',
    questionLockedAndClosed: 'The Question is locked and closed.',
    unlockQuestion: 'Unlock Question',
    duplicateQuestion: 'Duplicate Question',
    deleteQuestion: 'Delete Question',
    editDescription: 'Edit Description',
    scoreGreaterThanInstrument: 'The questions score is greater than the score of {entity}',
    scoreLessThanInstrument: 'The questions score is less than the score of {entity}',
    questionType: 'Question type',
    questionTypeNotBelongToSituation: 'The Question type does not belong to the {entity}.',
    questionNotSaved: 'Question not saved',
    questionSaved: 'Question saved',
    automaticScore: 'Automatic Score',
    scoreCannotBeLessThanZero: 'The score must not be less than 0',
    assignedScoreGreaterThanQuestion: 'The assigned score is greater than the question score',
    addCorrectAnswer: 'Add Correct Answer',
    addIncorrectAnswer: 'Add Incorrect Answer',
    correctAnswer: 'Correct Answer',
    clearCorrectAnswer: 'Clear Correct Answer',
    editCorrectAnswer: 'Edit the Correct Answer',
    incorrectAnswer: 'Incorrect Answer',
    clearIncorrectAnswer: 'Clear Incorrect Answer',
    editIncorrectAnswer: 'Edit the Incorrect Answer',
    clearFeedback: 'Clear Feedback',
    modifyCorrectAnswer: 'Modify the Correct Answer',
    modifyIncorrectAnswer: 'Modify the Incorrect Answer',
    modifyFeedback: 'Modify Feedback',
    modifyDescription: 'Modify Description',
    exceededWeighting: 'Exceeded {weighing}% assigned in IE, approximately by: {score}',
    availableWeighting2: 'Currently available {weighing}% for the selected IE, in score is: {score}',
    sureDeleteQuestion: 'Are you sure you want to delete the Question?',
    questionScoreUpdated: 'Question score updated.',
    evaluateeScoreUpdated: 'Evaluatee score updated.',
    questionCopied: 'Question duplicated.',
    sureChangeQuestionScore: 'Are you sure you want to change the question score?',
    changeScoreWhenGradeFixed: 'when the evaluation grade is already fixed, or do you want to change the grade to <strong>automatic</strong> so that it is recalculated based on what you are modifying?',
    imSure: "I'm sure",
    keepAssignedGrade: 'Keep assigned grade',

    // ========== MatchingQuestion ==========
    term1: 'Term 1',
    term2: 'Term 2',
    selectCorrectOptionsNumber: 'Select the number of correct options',
    optionsNumber: 'Options No.',
    answer: 'Answer',
    addAlternative: 'Add alternative',
    alternativeAdded: 'Alternative added',

    // ========== MatchingQuestionDraggableOption ==========
    deleteAlternative: 'Delete Alternative',
    addTermsToNextConcept: 'Add terms to next concept',
    clearAlternative: 'Clear Alternative',
    selectAlternative: 'Select Alternative',
    maxAssociationsReached: 'Maximum associations reached for {text}',
    removeSelection: 'Remove Selection',
    sureDeleteAlternative: 'Are you sure you want to delete the alternative?',
    alternativeDeleted: 'Alternative deleted',

    // ========== MatchingQuestionScore ==========
    scoreDistributionTable: 'Score distribution table',

    // ========== MatchingQuestionScoreInput ==========
    optionsTotalScoreGreaterThanQuestion: 'The total score of the options is greater than the total score of the question',

    // ========== LimitQuestion ==========
    limitAnswerLength: 'Limit answer length',
    limitBy: 'Limit by',
    setLimit: 'Set limit',
    limitAnswerLengthIn: 'Limit answer length to {length} {type}',
    answerTextHere: 'Answer text here',
    answerExceedsTeacherLimit: 'The answer exceeds the limit set by the {entity}',
    answerIsEmpty: 'The answer is empty',
    savedAnswer: 'Answer saved',

    // ========== SelectQuestionOptions ==========
    toAssignCorrectAnswerMustGiveScore: 'To assign the correct answer, you must give a score to the question',
    correctAlternative: 'Correct alternative',
    writeAtLeastOneCharacter: 'Write at least one character',
    optionsToSelect: 'Options to select',
    scoreCalculationMethod: 'Score calculation method',
    alternativeModified: 'Alternative modified',

    // ========== NewInstrumentForm ==========
    endDate: 'Submission Date',
    defineEndDate: 'Define submission date',
    mustEnterValidEndDate: 'You must enter a valid submission date.',
    endTime: 'Submission Time',
    defineEndTime: 'Define submission time',
    mustEnterEndTime: 'You must enter the submission time.',
    visibleByEvaluatees: 'Visible to evaluatees',
    visibleByEvaluateesTooltip: 'This option allows the Student to view the {entity}',
    missingDistributeScore: 'Score distribution is missing in the questions according to the {entity} score',
    allowAttachFiles: 'Allow attaching files',
    allowAttachFilesTooltip: 'This option allows the Student to attach files for their {entity}',
    allowReopen: 'Allow reopening',
    allowReopenTooltip: 'This option allows the Student to reopen the {entity} while it is active in order to modify their previous answers, without losing them and respecting the start and end dates.',
    maxReopenings: 'Number of reopenings',
    reopenEntity: 'Reopen {entity}',
    reopenEntityTooltip: 'You have {count} reopenings left.',
    sureToReopenEntity: 'Are you sure you want to reopen the {entity}?',
    reopenKeepsPreviousAnswers: 'Your previous answers will be kept and you can modify them while the evaluation is active.',
    reopenedEntity: 'The {entity} was reopened successfully.',
    reopeningsUsed: 'Reopenings used',
    lockDescriptorCreation: 'Lock {entity} creation',
    lockDescriptorCreationTooltip: 'This option allows blocking the Teacher profile from creating new {entity1} in the {entity2} view',
    lockSegmentCreationTooltip: 'This option allows blocking the creation of {entity} for Teachers',
    lockQuestionCreation: 'Lock question creation',
    lockQuestionCreationTooltip: 'This option allows blocking the creation of questions for Teachers',
    allowGroupCreation: 'Allow {entity} creation',
    allowGroupCreationTooltip: 'This option allows the creation of {entity}',
    selectAttachments: 'Select Attachments',
    allowAutoEvaluateTooltip2: 'This option allows the Student to self-evaluate when answering.',
    cannotDeleteInstrumentClosed: 'Cannot delete because the instrument is closed',
    cannotDeleteStudentEntered: 'Cannot delete because a student entered the test or was graded',

    // ========== NewInstrumentForm (methods) ==========
    instrumentWeighingZeroTitle: 'The {entity} has a weighting of 0%. Are you sure you want to continue?',
    instrumentWeighingZeroWarning: 'This instrument has a weighting of 0%',
    sureToSaveInstrumentWithGroups: 'Are you sure you want to save the {entity} given that there are <b>Groups</b> already created?',
    actionCannotBeRevertedGroupsDeleted: 'This action cannot be undone and the groups will be deleted!',
    instrumentCreated: 'The {entity} was created',
    instrumentEdited: 'The {entity} was edited',
    sureToDeleteInstrument: 'Are you sure you want to delete the <b>{entity}</b>?',

    // ========== ContainerInstrument ==========
    updateInstrumentInCreatedSections: 'Update {entity} in created {sections}',
    colorBlueSectionDescription: 'The {instrument} is not in the {section}, but the container {evaluation} is — a copy of the current one will be created.',
    colorGreenSectionDescription: 'The {instrument} in the {section} is deleted and replaced by a copy of the current one.',
    colorOrangeSectionDescription: 'The {instrument} in the {section} is kept, and a copy of the current one is added.',
    colorRedSectionDescription: 'The container {evaluation} is not in the {section}, it is not possible to create a copy of the current one.',
    listOfEntityToNavigate: 'List of {entity} to navigate:',
    instrumentsUpdatedInSections: 'The {entity} were updated in the following {sections}:',
    deletedAndRecreated: 'Deleted and Recreated:',
    duplicated: 'Duplicated:',
    recreatedMale: 'Recreated:',
    evaluationWillStartOn: 'The evaluation will start on',
    within: 'Within:',
    noPermissionToAnswer: 'You do not have permission to answer',
    startEntity: 'Start {entity}',
    finalizeEntity: 'Finish {entity}',
    hideEntity: 'Hide {entity}',
    printEntity: 'Print {entity}',
    uploadFile: 'Upload File',
    hidePrintScore: 'Hide <strong>Score</strong> when Printing',
    hidePrintWeighting: 'Hide <strong>Weighting</strong> when Printing',
    wantToStartAnswering: 'Do you want to start answering the {entity}?',
    instrumentRequiresConsent: 'The completion of this {entity} must have the authorization or consent of the student.',
    begin: 'Begin',
    continueAnswering: 'Continue answering',
    missingQuestionsToAnswer: 'You still need to answer the following questions:',
    notAttachedFileYet: 'You have not attached any file yet.',
    sureToFinalizeEntity: 'Are you sure you want to <strong>finish</strong> the {entity}?',
    answersSubmittedThanks: 'Your answers have been submitted successfully. Thank you for completing the {entity}.',
    answersWillBeSubmittedCannotUndo: 'Your answers will be submitted and this action cannot be undone!',
    instrumentFinishedTitle: '{entity} finished!',
    anotherInstrumentAvailable: 'You have another {entity} available to answer: <strong>{title}</strong>. Would you like to continue with it now?',
    goToNextInstrument: 'Go to next {entity}',
    evaluationNotAssignedTitle: 'This {entity} is not assigned to your account',
    evaluationNotAssignedText: 'You can review the ones assigned to you from the home page.',
}
